import cx from 'classnames';
import * as React from 'react';
import { CheckIcon } from './icon/check-icon';
import styles from './list.module.scss';

type CheckItemProps = {
  children: React.ReactNode;
  className?: string;
};

export const CheckedItem = (props: CheckItemProps) => (
  <li
    className={cx(
      'flex items-center text-left text-lg relative mb-2',
      props.className
    )}
  >
    <CheckIcon
      className={`fill-current text-green-500 inline-block ${styles.icon}`}
      width={36}
    />
    {props.children}
  </li>
);
